(() => {
  const ROOT_SELECTOR = '.js-product-view-banner-root';
  const SWIPER_SELECTOR = '.js-product-view-banner-swiper';
  const PAGINATION_SELECTOR = '.js-product-view-banner-pagination';
  const MOBILE_MQ = '(max-width: 989px)';

  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

  const destroyRoot = (root) => {
    if (!root?._productViewBannerSwiper) return;
    try {
      root._productViewBannerSwiper.destroy(true, true);
    } catch (_) {}
    root._productViewBannerSwiper = null;
  };

  const initRoot = (root) => {
    if (!root || root._productViewBannerSwiper) return;
    if (typeof window.Swiper === 'undefined') return;
    if (!isMobile()) return;

    const swiperEl = root.querySelector(SWIPER_SELECTOR);
    if (!swiperEl) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return;

    const paginationEl = root.querySelector(PAGINATION_SELECTOR);
    const usePagination = slideCount > 1 && paginationEl;

    root._productViewBannerSwiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      watchOverflow: true,
      allowTouchMove: slideCount > 1,
      pagination: usePagination
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
    });
  };

  const scan = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      destroyRoot(root);
      initRoot(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  const mq = window.matchMedia(MOBILE_MQ);
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', scan);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(scan);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      destroyRoot(root);
      initRoot(root);
    });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll(ROOT_SELECTOR).forEach(destroyRoot);
  });
})();
